import { FunctionComponent } from 'react';
import {
  designTokens,
  Statistic,
  TableCell,
  TableRow,
  Typography,
} from '@monorepo/nova-ui';

interface DetailItem {
  title: string;
  value: number | string;
  prefix?: string;
  precision?: number;
  isText?: boolean;
  suffix?: string;
}

interface Props {
  details: DetailItem[];
  isMobile: boolean;
}

const InvoiceDetails: FunctionComponent<Props> = ({ details, isMobile }) => {
  if (details.length === 0) {
    return null;
  }

  return (
    <>
      {details.map((detail, i) => (
        <TableRow key={i}>
          <TableCell>
            <Typography variant="caption" color="text.secondary">
              {detail.title}
            </Typography>
          </TableCell>
          <TableCell colSpan={isMobile ? 2 : 3}></TableCell>
          <TableCell align="right">
            <Typography
              variant="body2"
              fontWeight={designTokens.typography.fontWeights.medium}
            >
              {detail.isText ? (
                detail.value
              ) : (
                <Statistic
                  prefix={detail.prefix}
                  suffix={detail.suffix}
                  value={detail.value || 0}
                  precision={detail.precision || 0}
                  align="right"
                />
              )}
            </Typography>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default InvoiceDetails;
